import cn from 'classnames';
import { ArticleHeading3, IconChevronDown16 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IAccordionItemProps {
  leftEnhancer?: React.ReactNode;
  title: string;
  isActive?: boolean;
  isFirst?: boolean;
  onClick?(): void;
}

export const AccordionItem: React.FC<React.PropsWithChildren<IAccordionItemProps>> = ({
  title,
  leftEnhancer,
  isFirst,
  isActive,
  onClick,
  children,
}) => {
  return (
    <div data-testid="accordion-element" className={cn(styles['container'], isFirst && styles['container-first'])}>
      <div className={styles['head']} onClick={onClick}>
        <div className={styles['title']}>
          {leftEnhancer && <div className={styles['left-enhancer']}>{leftEnhancer}</div>}
          <ArticleHeading3>{title}</ArticleHeading3>
        </div>
        <div className={cn(styles['chevron'], isActive && styles['chevron-active'])}>
          <IconChevronDown16 color="primary_100" />
        </div>
      </div>
      <div className={cn(styles['body'], isActive && styles['body-active'])}>{children}</div>
    </div>
  );
};

AccordionItem.displayName = 'AccordionItem';
